import React, {PropsWithChildren} from 'react';
import {Animation} from '@forecast-it/design-system';
import styled from 'styled-components';

const SpinnerWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

const AnimationWrapper = styled.div<{size: number}>`
	width: ${({size}) => `${size}px`};
	height: ${({size}) => `${size}px`};
`;

export enum SpinnerStyle {
	onDark = 'White',
	onLight = '',
}

type SpinnerProps = {
	spinning: boolean;
	style?: SpinnerStyle;
	size?: number;
};

const Spinner = ({
	children,
	spinning,
	style = SpinnerStyle.onDark,
	size = 24,
}: PropsWithChildren<SpinnerProps>): React.JSX.Element => {
	return (
		<SpinnerWrapper>
			{spinning ? (
				<AnimationWrapper size={size}>
					<Animation animation={'loader' + style} />
				</AnimationWrapper>
			) : (
				children
			)}
		</SpinnerWrapper>
	);
};

export default Spinner;
